<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>
<script>
import config from "@/config";

export default {
  mounted(){
    window.document.title = config.appName
    console.log(JSON.stringify(config,null,2))
  }
}
</script>
<style lang="scss">
</style>
